import type { MenuConfig } from '~typings/menu'

import configuracion from './configuracion'
import mantenimiento from './mantenimiento'
import permisos, { RESOURCE_ADMINISTRACION_PG } from '@/auth/permissions/modules/administracionPg'

const menuList: MenuConfig[] = [
    {
        title: 'administracion.titulo_v2',
        fontIcon: 'folder',
        action: permisos._root,
        resource: RESOURCE_ADMINISTRACION_PG,
        children: [
            {
                title: 'global.menu.mantenimiento',
                icon: 'EditIcon',
                action: permisos.mantenimiento._perm,
                resource: RESOURCE_ADMINISTRACION_PG,
                children: mantenimiento,
            },
            {
                title: 'global.menu.configuracion',
                icon: 'SettingsIcon',
                action: permisos.configuracion._perm,
                resource: RESOURCE_ADMINISTRACION_PG,
                children: configuracion,
            },
        ],
    },
]

export default menuList
